import { NgModule } from '@angular/core';
import { CustomMinDirective } from './min-validator.directive';
import { CustomMaxDirective } from './max-validator.directive';
import { PositiveIntegerDirective } from './positive-integer.directive';

@NgModule({
  declarations: [
    CustomMaxDirective,
    CustomMinDirective,
    PositiveIntegerDirective
  ],
  imports: [
  ],
  exports: [
    CustomMaxDirective,
    CustomMinDirective,
    PositiveIntegerDirective
  ]
})
export class TmcLegacyValidatorModule { }
